import Services from '../../service/ApiServices'

export const GET_All_BED_STATUS = "settings/GET_All_BED_STATUS";
export const ADD_BED_STATUS = "settings/ADD_BED_STATUS";
export const EDIT_TREE_NODE = "settings/EDIT_TREE_NODE";
export const DELETE_TREE_NODE = "settings/DELETE_TREE_NODE";
export const GET_All_BED_TYPES = "settings/GET_All_BED_TYPES";
export const ADD_BED_TYPES = "settings/ADD_BED_TYPES";
export const GET_All_BED_TAGS = "settings/GET_All_BED_TAGS";
export const ADD_BED_TAGS = "settings/ADD_BED_TAGS";

export const GET_All_ATTENDANCE_STATUS = "settings/GET_All_ATTENDANCE_STATUS";
export const ADD_ATTENDANCE_STATUS = "settings/ADD_ATTENDANCE_STATUS";
export const GET_DAY_CODES = "settings/GET_DAY_CODES";

export const GetBedStatus = async ()=>{
    var response = await Services.Setting.getAddBedStatus();
    return {type: GET_All_BED_STATUS, data: response.data }
}
export const  AddBedStatus = async (data)=>{
    let result;
    if(data.id){
        result = await Services.Setting.updateBedStatus(data);  
    } else{
        result = await Services.Setting.saveBedStatus(data); 
    }
    return {type:ADD_BED_STATUS, data: result.data }
}

export const GetBedTypes = async ()=>{
    var response = await Services.Setting.getAddBedTypes();
    return {type: GET_All_BED_TYPES, data: response.data }
}

export const  AddBedType = async (data)=>{
    let result;
    if(data.id){
        result = await Services.Setting.updateBedType(data);  
    } else{
        result = await Services.Setting.saveBedType(data); 
    }
    return {type:ADD_BED_TYPES, data: result.data }
}

export const GetBedTags = async ()=>{
    var response = await Services.Setting.getAddBedTags();
    return {type: GET_All_BED_TAGS, data: response.data }
}

export const  AddBedTag = async (data)=>{
    let result;
    if(data.id){
        result = await Services.Setting.updateBedTag(data);  
    } else{
        result = await Services.Setting.saveBedTag(data); 
    }
    return {type:ADD_BED_TAGS, data: result.data }
}


export const GetAttendanceStatus = async ()=>{
    var response = await Services.Setting.getAttendanceStatus();
    return {type: GET_All_ATTENDANCE_STATUS, data: response.data }
}

export const  AddAttendanceStatus = async (data)=>{
    let result;
    if(data.id){
        result = await Services.Setting.updateAttendanceStatus(data);  
    } else{
        result = await Services.Setting.saveAttendanceStatus(data); 
    }
    return {type:ADD_ATTENDANCE_STATUS, data: result.data }
}


export const GetDayCodes = async ()=>{
    var response = await Services.Setting.getDayCodes();
    return {type: GET_DAY_CODES, data: response.data }
}

